import script from "./WhyChoose.vue?vue&type=script&setup=true&lang=js"
export * from "./WhyChoose.vue?vue&type=script&setup=true&lang=js"

import "./WhyChoose.vue?vue&type=style&index=0&id=dca88c4a&lang=scss"

const __exports__ = script;

export default __exports__